import { render } from "./FormDeletePage.vue?vue&type=template&id=16e68a3e"
import script from "./FormDeletePage.vue?vue&type=script&lang=js"
export * from "./FormDeletePage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__